import api from './api';
import authHeader from './auth-header';

class DashboardService {
    getStats(date) {
        const url = `/dashboard/stats?date=${date}`;
        return api.get(url, { headers: authHeader() });
    }

    getAnalytics(period, employeeId) {
        const params = new URLSearchParams({ period: String(period) });
        if (employeeId && employeeId !== 'all') {
            params.set('employeeId', String(employeeId));
        }
        const url = `/dashboard/analytics?${params.toString()}`;
        return api.get(url, { headers: authHeader() });
    }

    // Nástenka: posledné príchody, prestávky a odchody + kto je práve v práci.
    getActivity(limit = 20) {
        const url = `/dashboard/activity?limit=${encodeURIComponent(limit)}`;
        return api.get(url, { headers: authHeader() });
    }
}

const dashboardService = new DashboardService();
export default dashboardService;
